import {SVGProps} from 'react';

const Icon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="32"
        viewBox="0 0 32 32"
        width="32"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M7 28.4092V5C7 3.89543 7.89543 3 9 3H23C24.1046 3 25 3.89543 25 5V28.4092C25 28.6922 24.7142 28.8857 24.4514 28.7806L20.1668 27.0667C20.0607 27.0243 19.9415 27.0292 19.8393 27.0803L16.1789 28.9106C16.0663 28.9669 15.9337 28.9669 15.8211 28.9106L12.1607 27.0803C12.0585 27.0292 11.9393 27.0243 11.8332 27.0667L7.54856 28.7806C7.28581 28.8857 7 28.6922 7 28.4092Z"
            fill="#F9F9F9"
            stroke="#3C3C3C"
            strokeWidth="2"
        />
        <circle
            cx="14"
            cy="10"
            fill="#C2C2C2"
            r="3"
            stroke="#3C3C3C"
            strokeWidth="2"
        />
        <path
            d="M11 17H13"
            stroke="#3C3C3C"
            strokeLinecap="round"
            strokeWidth="2"
        />
        <path
            d="M17 17H21"
            stroke="#3C3C3C"
            strokeLinecap="round"
            strokeWidth="2"
        />
        <path
            d="M11 21H21"
            stroke="#3C3C3C"
            strokeLinecap="round"
            strokeWidth="2"
        />
    </svg>
);

export default Icon;
